import React from 'react';
import { StarRating } from './StarRating';
import { formatReviewDateTimeIso } from '../../utils/dateDisplay';

function formatTipRupee(amount) {
  if (amount == null || amount === '' || Number(amount) <= 0) return null;
  const n = Number(amount);
  if (!Number.isFinite(n)) return null;
  const formatted = Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
  return `₹${formatted}`;
}

/**
 * Layout matches android item_review.xml: name/date + stars, then description|amount row, then tags.
 * @see android/TipPay Emp/app/src/main/res/layout/item_review.xml
 */
export function ReviewCard({ review }) {
  const name = review.name || review.customerName || 'Guest';
  const when = review.createdTime || review.createdAt;
  const tip = formatTipRupee(review.tipAmount);
  const tags = Array.isArray(review.tags) ? review.tags.filter(Boolean) : [];
  const comment = (review.comment || '').trim();
  const rating = review.rating != null ? Number(review.rating) : 0;
  const showMetaRow = Boolean(comment || tip);

  return (
    <article className="review-card">
      <div className="review-card__top">
        <div className="review-card__who">
          <p className="review-card__name">{name}</p>
          {when ? <p className="review-card__date">{formatReviewDateTimeIso(when)}</p> : null}
        </div>
        <StarRating value={rating} size="sm" className="review-card__stars" />
      </div>

      {showMetaRow ? (
        <div className="review-card__meta-row">
          {comment ? (
            <p className="review-card__comment">{comment}</p>
          ) : (
            <span className="review-card__meta-spacer" aria-hidden="true" />
          )}
          {tip ? <span className="review-card__tip">{tip}</span> : null}
        </div>
      ) : null}

      {tags.length > 0 ? (
        <div className="review-card__tags">
          {tags.map((tag) => (
            <span key={tag} className="review-card__tag">
              {tag}
            </span>
          ))}
        </div>
      ) : null}
    </article>
  );
}
